export default __webpack_public_path__ + "images-processed/cdek-c0f0871762b9e1c0bb3fdf875482aaa6.png";